import { ImpulseFormShape, ImpulseFormUnit } from "~/tools/impulse-form";
import { isShallowEqual } from "~/tools/is-shallow-equal";

import type { DashboardSpec } from "../../../../common/dashboard-spec";

export function initSettingsFormState(spec: DashboardSpec) {
	/**
	 * react-impulse-form does not support `null` as a valid output value
	 * so it has to wrap the output value in an object
	 * TODO drop this wrapper when react-impulse-form supports `null` as a valid output value https://github.com/owanturist/react-impulse/issues/894
	 */
	return ImpulseFormShape({
		timeRange: ImpulseFormUnit(spec.timeRange, {
			isInputEqual: isShallowEqual,
			transform: (value) => ({ value }),
		}),
		refreshInterval: ImpulseFormUnit(spec.refreshInterval, {
			isInputEqual: isShallowEqual,
			transform: (value) => ({ value }),
		}),
		saveVariables: ImpulseFormUnit(spec.saveVariables),
	});
}

export type SettingsFormState = ReturnType<typeof initSettingsFormState>;
